import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import { compose } from '../../../services/utilityFunctions';
import userProp from '../../../commonComponents/propTypes/userProp';
import withCSRF from '../../../commonComponents/withCSRF';

function SellerInfo({ t, seller, isOpportunity }) {
  const name =
    seller?.firstName && seller.lastName
      ? `${seller.firstName} ${seller.lastName}`
      : seller.username;

  const title = isOpportunity
    ? t('opportunity.order.madeBy')
    : `${t('shop.order.madeBy')}`;

  return (
    <div className="m-portlet seller-container">
      <h5>{title}:</h5>
      <div className="row seller-container-detail">
        <div>
          <img
            src={seller?.image?.thumb || '/images/no_user.png'}
            alt="seller"
          />
        </div>
        <div>
          <p>{name}</p>
        </div>
      </div>
    </div>
  );
}

SellerInfo.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  seller: PropTypes.shape(userProp.propType).isRequired,
  isOpportunity: PropTypes.bool,
};

SellerInfo.defaultProps = {
  isOpportunity: false,
};

export default compose(translate, withCSRF)(SellerInfo);
